export default {
  optionNutritionColor: '',
};
